import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'userReports/FETCH_REQUEST'
const FETCH_SUCCESS = 'userReports/FETCH_SUCCESS'
const FETCH_FAILURE = 'userReports/FETCH_FAILURE'
const GENERATE_REPORT_REQUEST = 'userReports/GENERATE_REPORT_REQUEST'
const GENERATE_REPORT_SUCCESS = 'userReports/GENERATE_REPORT_SUCCESS'

const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function generateReportRequest(payload = {}) {
  return {
    type: GENERATE_REPORT_REQUEST,
  }
}

export function generateReportSuccess(payload) {
  return {
    type: GENERATE_REPORT_SUCCESS,
    payload
  }
}


export function loadUserReports(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())

    const promise = api(`api/v1/users/${id}/reports`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

export function generateUserReport(id, options = {}) {
  return (dispatch, _getState) => {
    dispatch(generateReportRequest())


    const promise = api(`api/v1/users/${id}/reports/generate`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }
        toastr.success(json.success)
        dispatch(generateReportSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          toastr.error(errors)
        })
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors
      });
    default:
      return state
  }
}
